<template>
  <layout-card :isCustomizable="settings.isCustomizable"
    :type="settings.context"
    :error="error"
    @hide-card="$emit('hide-card', 'ticket')"
    @refresh-card="fetchCard('ticket', {}, true)"
    class="card-ticket card-ticket"
    :placeholder="placeholder"
    :loading="loading"
  >
    <template slot="title">{{ name }}</template>

    <template slot="content" v-if="data && data.length > 0">
      <template-ticket-card
        :data="data"
        :name="name"
        :settings="settings"
        :type="type"
        context="ticket"
      />
    </template>
  </layout-card>
</template>

<script>
import LayoutCard from "./LayoutCard.vue";
import CardMixin from "./CardMixin.js";
import TemplateTicketCard from "./TemplateTicketCard.vue";

export default {
  mixins: [CardMixin],
  components: {
    LayoutCard,
    TemplateTicketCard
  },
  computed: {
    placeholder() {
      return this.$l10n.__('Aucun ticket ne vous est assigné');
    }
  }
};
</script>